export function isIframe(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    // Если доступ к top запрещён из-за cross-origin,
    // значит, мы точно в iframe (иначе доступа не было бы)
    return true;
  }
}
